import { lazy } from "react";
import { Navigate, useLocation, Route } from "react-router-dom";
import { includes } from "lodash";
import { ROLES } from "src/constants";
import FreelanceDriverLayout from "src/_modules/layouts/FreelanceDriver";
import LazyRouteWrapper from "../LazyRouteWrapper";

const LanguageSetting = lazy(() => import("src/modules/Settings/LanguageSetting"));
const WhatsappMessagesSettings = lazy(() => import("src/modules/Settings/WhatsappMessagesSettings"));
const ZoneOrderList = lazy(() => import('src/modules/Order/ZoneOrderList'));
const OrderList = lazy(() => import("src/modules/Order/OrderList"));
const AddOrder = lazy(() => import('src/modules/Order/OrderManagement'));
const OrderDetails = lazy(() => import("src/modules/Order/OrderDetails"));
const DriverList = lazy(() => import('src/_modules/Users/Driver/DriverList'));
const AddDriver = lazy(() => import('src/_modules/Users/Driver/DriverManagement'));
const DriverDetails = lazy(() => import("src/_modules/Users/Driver/DriverDetails"));
const ZoneList = lazy(() => import("src/views/ZoneList"));
const TrackDrivers = lazy(() => import("src/_modules/Users/Driver/TrackDrivers"));
const RecentOrders = lazy(() => import("src/modules/Order/OrdersFilter/RecentOrders"));
const Warehouse = lazy(() => import("src/modules/Warehouse"));
const SubscriptionManagement = lazy(() => import("src/views/SubscriptionManagement"));
const RecentTasks = lazy(() => import("src/_modules/Tasks/TasksFilter/RecentTasks"));
const CreateTask = lazy(() => import("src/_modules/Tasks/FreelanceDriver/CreateTask"));
const ZonesTasksCount = lazy(() => import("src/_modules/Tasks/FreelanceDriver/ZonesTasksCount"));
const ZonesTasksList = lazy(() => import("src/_modules/Tasks/FreelanceDriver/ZonesTasksList"));
const TaskDetails = lazy(() => import("src/_modules/Tasks/FreelanceDriver/TaskDetails"));
const OrdersList = lazy(() => import("src/_modules/Tasks/FreelanceDriver/OrdersList"));
const TaskOrderDetails = lazy(() => import("src/_modules/Tasks/FreelanceDriver/OrderDetails"));
const FreelanceDriverAccount = lazy(() => import("src/_modules/Account/FreelanceDriverAccount"));

const CheckBeforeEnterMerchant = (currentUser) => {
    const location = useLocation()
    if (location.pathname !== "/" && currentUser?.currentStatus === "BLOCKED") {
        return <Navigate to="/blocked" />
    } else if (currentUser && includes([ROLES.freelanceDriver], currentUser?.role)) {
        if (location.pathname === "/freelance_driver") {
            return <Navigate to="/freelance_driver/tasks/zones?status=TASK_ASSIGNED_TO_DRIVER_FOR_PICK_UP" />
        }
        return <FreelanceDriverLayout />
    }
    return <Navigate to="/auth/general" />
}

const freelanceDriverRoutes = (currentUser) => (
    <>
        <Route path="freelance_driver" element={CheckBeforeEnterMerchant(currentUser)}>
            <Route path="orders">
                <Route path="" element={<LazyRouteWrapper><ZoneOrderList /></LazyRouteWrapper>} />
                <Route path="list" element={<LazyRouteWrapper><OrderList /></LazyRouteWrapper>} />
                <Route path="add" element={<LazyRouteWrapper><AddOrder /></LazyRouteWrapper>} />
                <Route path=":id" element={<LazyRouteWrapper><OrderDetails /></LazyRouteWrapper>} />
                <Route path="filter" element={<LazyRouteWrapper><RecentOrders key="orders-filter" /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="tasks">
                <Route path="create" element={<LazyRouteWrapper><CreateTask /></LazyRouteWrapper>} />
                <Route path="filter" element={<LazyRouteWrapper><RecentTasks /></LazyRouteWrapper>} />
                <Route path="zones" element={<LazyRouteWrapper><ZonesTasksCount /></LazyRouteWrapper>} />
                <Route path="zone_tasks/:zoneId" element={<LazyRouteWrapper><ZonesTasksList /></LazyRouteWrapper>} />
                <Route path=":taskId" element={<LazyRouteWrapper><TaskDetails /></LazyRouteWrapper>} />
                <Route path="order/:id" element={<LazyRouteWrapper><TaskOrderDetails /></LazyRouteWrapper>} />
                <Route path="orders" element={<LazyRouteWrapper><OrdersList /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="drivers">
                <Route path="add" element={<LazyRouteWrapper><AddDriver /></LazyRouteWrapper>} />
                <Route path="" element={<LazyRouteWrapper><DriverList /></LazyRouteWrapper>} />
                <Route path=":id" element={<LazyRouteWrapper><DriverDetails /></LazyRouteWrapper>} />
                <Route path="track" element={<LazyRouteWrapper><TrackDrivers /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="zones">
                <Route path="" element={<LazyRouteWrapper><ZoneList /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="settings">
                <Route path="language" element={<LazyRouteWrapper><LanguageSetting /></LazyRouteWrapper>} />
                <Route path="whatsapp" element={<LazyRouteWrapper><WhatsappMessagesSettings /></LazyRouteWrapper>} />
                <Route path="*" element={<Navigate to="/errors/404" />} />
            </Route>
            <Route path="account" element={<LazyRouteWrapper><FreelanceDriverAccount /></LazyRouteWrapper>} />
            <Route path="warehouse" element={<LazyRouteWrapper><Warehouse /></LazyRouteWrapper>} />
            <Route path="subscriptions" element={<LazyRouteWrapper><SubscriptionManagement /></LazyRouteWrapper>} />
            <Route path="*" element={<Navigate to="/errors/404" />} />
        </Route>
    </>
)

export default freelanceDriverRoutes;
